import { alert } from '@/plugins/notification'
import errorBorder from './errorBorder'
import { isValidLatitude, isValidLongitude } from '@/utils/validations'
export const emptyString = (str, field, dataValidation, showAlert = true, showMessage = false, message) => {
  if (str === '' || str === null || str === undefined) {
    message = message ?? `${field} is required`
    showAlert && alert(message)
    message = showMessage ? message : null
    errorBorder(dataValidation, true, message)
    return false
  }
  errorBorder(dataValidation, false)
  return true
}

export const length = (str, field, min, max, dataValidation, showAlert = true, showMessage = false, message = undefined) => {
  if (str.length < min || str.length > max) {
    if (max === undefined) {
      message = `${field} must be greater than or equal to ${min}`
    } else if (min === undefined) {
      message = ` must be less than or equal to ${max}`
    } else if (min === max) {
      message = `${field} must be ${max} characters`
    } else {
      message = `${field} must be between ${min} and ${max} characters`
    }
    message = showMessage ? message : undefined
    errorBorder(dataValidation, true, message)
    return false
  }
  errorBorder(dataValidation, false)
  return true
}

export const email = (str, field, dataValidation, showAlert = true, showMessage = false, message = undefined) => {
  const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (!re.test(str)) {
    message = message ?? `${field} must be a valid email address`
    showAlert && alert(message)
    message = showMessage ? message : null
    errorBorder(dataValidation, true, message)
    return false
  }
  errorBorder(dataValidation, false)
  return true
}

export const noSpecialChars = (str, field, dataValidation, showAlert = true, showMessage = false, message) => {
  message = `${field} must be alphanumeric`
  const re = /^[a-zA-Z0-9_-\s]+$/
  if (!re.test(str)) {
    showAlert && alert(message)
    message = showMessage ? message : null
    errorBorder(dataValidation, true, message)
    return false
  }
  errorBorder(dataValidation, false)
  return true
}

export const password = (str, field, dataValidation) => {
  const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{6,}$/
  if (!re.test(str)) {
    alert(`${field} must be at least 6 characters, contain at least one lowercase letter, one uppercase letter, one number and one special character`)
    errorBorder(dataValidation, true)
    return false
  }
  errorBorder(dataValidation, false)
  return true
}

export const emptylist = (str, field, dataValidation) => {
  if (str.length === null || str.length === 0) {
    alert(`${field} is required`)
    errorBorder(dataValidation, true)
    return false
  }
  errorBorder(dataValidation, false)
  return true
}

export const checkTrue = (boolValue, message, dataValidation, showAlert = true, showMessage = false) => {
  if (!boolValue) {
    showAlert && alert(message)
    message = showMessage ? message : null
    errorBorder(dataValidation, true, showMessage ? message : null)
    return false
  }
  return true
}

export const RegexValidator = (value, regx, message, dataValidation, showAlert = true, showMessage = false) => {
  if (!(new RegExp(regx).test(value))) {
    showAlert && alert(message)
    message = showMessage ? message : null
    errorBorder(dataValidation, true, message)
    return false
  }
  errorBorder(dataValidation, false)
  return true
}

export const MatchString = (str1, str2, message, dataValidation) => {
  if (str1 !== str2) {
    alert(message)
    errorBorder(dataValidation, true)
    return false
  }
  errorBorder(dataValidation, false)
  return true
}

export const positiveFloat = (num, field, dataValidation, showAlert = true, showMessage = false, message = undefined) => {
  const floatRegex = /^\d+(\.\d{1,4})?$/

  if (floatRegex.test(num)) {
    errorBorder(dataValidation, false)
    return true
  }
  message = message ?? `${field} must be a +ve number`
  showAlert && alert(message)
  message = showMessage ? message : null

  errorBorder(dataValidation, true, message)
  return false
}
export const isValidLatitudeTenant = (latitude, field, dataValidation, showAlert = true, showMessage = false, message = null) => {
  const isValid = isValidLatitude(latitude)
  message = message ?? `${field} must be a valid latitude`
  if (!isValid) {
    showAlert && alert(message)
    message = showMessage ? message : null
    errorBorder(dataValidation, true, message)
    return false
  }
  errorBorder(dataValidation, false)
  return true
}

export const isValidLongitudeTenant = (longitude, field, dataValidation, showAlert = true, showMessage = false, message = null) => {
  const isValid = isValidLongitude(longitude)
  message = message ?? `${field} must be a valid longitude`
  if (!isValid) {
    showAlert && alert(message)
    message = showMessage ? message : null

    errorBorder(dataValidation, true, message)
    return false
  }
  errorBorder(dataValidation, false)
  return true
}
